import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/img/oto/emoji/large/oto_emoji_large_sleeping.png';
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("img", {
    "data-cy": "data-inconsistency-no-tests-found-state-image",
    src: _imports_0
}, null, -1);
import EmptyState from '@/components/_atoms/EmptyState.vue';
// utils
import { useMixpanelDataInconsistency } from '@/utilities/mixpanel';
// libs
import router from '@/router';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DataInconsistencyStateNoTestsFound',
    setup(__props) {
        const goHome = () => {
            useMixpanelDataInconsistency('view_integrations_data_inconsistency_go_home_button');
            router.push('/');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(EmptyState, {
                class: "data-inconsistency__no-tests-found",
                title: _ctx.$t('integrations.data-inconsistency.state-no-tests-found.title'),
                text: _ctx.$t('integrations.data-inconsistency.state-no-tests-found.text'),
                "button-text": _ctx.$t('integrations.data-inconsistency.btn-go-home'),
                "exec-function": goHome
            }, {
                image: _withCtx(() => [
                    _hoisted_1
                ]),
                _: 1
            }, 8, ["title", "text", "button-text"]));
        };
    }
});
